import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
		token: localStorage.getItem('token') ? localStorage.getItem('token') : '',
		refreshToken: localStorage.getItem('refreshToken') ? localStorage.getItem('refreshToken') : '',
		worktab: {
		  list: [
		    {
		      name: 'Main',
		      tabname: '首页',
		      path: '/main',
		    }
		  ],
		  current: {
		    name: 'Main',
		    tabname: '首页',
		    path: '/main',
		  },
		  fromPage: {
		    name: 'Main',
		    tabname: '首页',
		    path: '/main',
		  }
		},
		closingPage: [],
		screenWidth:document.documentElement.clientWidth, //屏幕宽度
		screenHeight:document.documentElement.clientHeight, //屏幕高度
		mingxiHeight: 'auto', //明细高度
		UserInfo: localStorage.getItem('UserInfo') ? localStorage.getItem('UserInfo') : '{}',
		
  },
  mutations: {
		setToken (state,token) {
			state.token =token.token;
			localStorage.setItem("token",token.token);
		  //console.log('setToken:' + state.token + ','+ token.token + ','+ localStorage.getItem('token'));
		},
		delToken (state) {
			state.token = '';
			localStorage.removeItem("token");
		  //console.log('delToken');
		},
		setRefreshToken (state,token) {
			state.refreshToken =token.token;
			localStorage.setItem("refreshToken",token.token);
		  //console.log('setToken:' + state.token + ','+ token.token + ','+ localStorage.getItem('token'));
		},
		delRefreshToken (state) {
			state.refreshToken = '';
			localStorage.removeItem("refreshToken");
		  //console.log('delToken');
		},
		worktabRemove (state, p) {
		  // 关闭标签
		  let ind = state.worktab.list.findIndex(s => s.name === p)
			//console.log(ind,p);
		  if (ind > -1) {
		    // 清理 keep alive - start
		    state.closingPage.push(state.worktab.list[ind].name);
		    // 清理 keep alive - end
		    state.worktab.list.splice(ind, 1)
		
		    localStorage.setItem("worktabList",JSON.stringify(state.worktab.list));
		
		    //console.log('remove',JSON.stringify(state.worktab.list));
		  }
		  if (p === state.worktab.current.name) {
		    // 是当前页，返回上一页
		    let ind2=state.worktab.list.findIndex(s => s.name === state.worktab.fromPage.name);
		    //console.log(ind2,state.worktab.list,state.worktab.fromPage.name);
		    if(ind2>-1)
		    {
		      router.back();
		      //router.push('/main');
		    }
		    else
		    {
		      router.push('/main');
		    }
		  }
		},
		worktabRemoveNoBack (state, p) {
		  // 关闭标签
		  let ind = state.worktab.list.findIndex(s => s.name === p)
		  if (ind > -1) {
		    // 清理 keep alive - start
		    state.closingPage.push(state.worktab.list[ind].name);
		    // 清理 keep alive - end
		    state.worktab.list.splice(ind, 1)
		
		    localStorage.setItem("worktabList",JSON.stringify(state.worktab.list));
		
		  }
		  //console.log(state.worktab.list,p);
		},
		worktabRoute (state, p) {
		  let list=localStorage.getItem("worktabList");
		  //console.log('list',list)
		  if(this.state.worktab.list.length<=1&&list&&list!=''){
		    this.state.worktab.list=JSON.parse(list);
		  }
		  let ind = state.worktab.list.findIndex(s => s.name === p.to.name)
		  //console.log(ind,p.to.name,p.from.name);
		  if (ind > -1) {
		    // 标签已存在
		    state.worktab.current = state.worktab.list[ind];
		    state.worktab.fromPage=p.from;
		  } else {
		    // 标签不存在，现在新建
		    state.worktab.list.push(p.to);
		    state.worktab.current = p.to;
		    state.worktab.fromPage=p.from;
		
		    localStorage.setItem("worktabList",JSON.stringify(state.worktab.list));
		
		    //console.log('add',localStorage.getItem("worktabList"));
		  }
		
		  let i=state.closingPage.findIndex(item=>item==p.to.name);
		  //console.log(i);
		  if(i>=0){
		    setTimeout(function(){
		      state.closingPage.splice(i,1);
		    },1000);
		
		  }
		  //console.log(state.closingPage);
		
		},
		worktabInit(state){ //用户登录时初始化tab页标签
		  let list=localStorage.getItem("worktabList");
		  //console.log('list',list)
		  if(list&&list!=''){
		    this.state.worktab.list=JSON.parse(list);
		  }
		
		},
		setUserInfo(state,userinfo) {
			state.UserInfo =userinfo;
			localStorage.setItem("UserInfo",userinfo);
		  //console.log('UserInfo:',userinfo);
		},
		delUserInfo (state) {
			state.UserInfo = '';
			localStorage.removeItem("UserInfo");
		  //console.log('UserInfo');
		}
		
  },
  actions: {
		worktabRemove ({commit}, p) {
		  commit('worktabRemove', p)
		},
		worktabRemoveNoBack ({commit}, p) {
		  commit('worktabRemoveNoBack', p)
		},
		worktabRoute ({commit}, p) {
		  commit('worktabRoute', p)
		}
  },
  modules: {
  }
})
